const getRelativeUrl = absoluteUrl => {
  const url = new URL(absoluteUrl);
  const relativePath = url.pathname + url.search + url.hash;

  return relativePath;
};

const getCurrentUrlWithSpecificBase = baseUrl => {
  const currentPathname = window.location.pathname;
  const currentSearch = window.location.search;

  return `${baseUrl}${currentPathname}${currentSearch}`
}
